import type { Window } from "./figures.ts";

const formats: Record<string, Intl.DateTimeFormat> = {};

export const dateTimeFormat = (locale: string, timezone: string, parts: Intl.DateTimeFormatOptions): Intl.DateTimeFormat =>
  (formats[`${locale} ${timezone} ${JSON.stringify(parts)}`] ??= new Intl.DateTimeFormat(locale, { ...parts, timeZone: timezone }));

type Instant = Date | string;

export const calendarDay = (instant: Instant, timezone: string): string =>
  dateTimeFormat("en-CA", timezone, { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(instant));

export function dayAndTime(instant: Instant, timezone: string): string {
  const day = dateTimeFormat("pt-BR", timezone, { day: "2-digit", month: "2-digit" }).format(new Date(instant));
  const time = dateTimeFormat("pt-BR", timezone, { hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date(instant));
  return `${day} às ${time}`;
}

export const shortDay = (day: string): string => `${day.slice(8, 10)}/${day.slice(5, 7)}`;

export const daysBetween = (from: string, to: string): number =>
  Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);

export const days = (window: Window): number => daysBetween(window.from, window.to) + 1;

export function formatCountdown(ms: number): string {
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 1) return "falta menos de 1 min";
  const hours = Math.floor(minutes / 60), rest = minutes % 60;
  if (hours === 0) return `${rest === 1 ? "falta" : "faltam"} ${rest} min`;
  return rest === 0 ? `${hours === 1 ? "falta" : "faltam"} ${hours} h` : `faltam ${hours} h ${rest} min`;
}

type DayWords = (day: string, today: string) => string;

export function deadlineWords(at: Instant, now: Instant, timezone: string, time: string, date: DayWords): string {
  const day = calendarDay(at, timezone), today = calendarDay(now, timezone);
  const ahead = daysBetween(today, day);
  if (ahead === 0) return `até ${time}`;
  return ahead === 1 ? `até ${time} de amanhã` : `até ${date(day, today)} às ${time}`;
}
